import { LayoutGroup } from './LayoutGroup';
import { GameOrientation } from '../../../Core/Core';

export class DynamicGrid extends LayoutGroup {
    protected paddingTop: number;
    protected spacing: number;
    protected vSpacing: number;
    protected layoutOrientation: GameOrientation;

    constructor(
        layoutOrientation: GameOrientation = GameOrientation.PORTRAIT,
        paddingTop: number = 20,
        spacing: number = 7,
        vSpacing: number = 0,
        ...elements: PIXI.Container[]
    ) {
        super(...elements);
        this.paddingTop = paddingTop;
        this.spacing = spacing;
        this.vSpacing = vSpacing;
        this.layoutOrientation = layoutOrientation;
    }

    protected buildLayout() {
        const sorted = this.elements.slice(0).sort((a, b) => b.width - a.width);
        const widest = sorted[0];
        if (!widest) {
            return;
        }

        const { spacing, vSpacing } = this;
        const gridWidth =
            this.layoutOrientation === GameOrientation.PORTRAIT
                ? widest.width
                : widest.width * 2 + spacing * 3;
        let totalHeight = this.paddingTop;
        let totalWidth = -gridWidth / 2;
        let lastHeight = 0;

        for (const element of this.elements) {
            if (totalWidth + spacing + element.width >= gridWidth - gridWidth / 2) {
                totalHeight += spacing + lastHeight;
                totalWidth = -gridWidth / 2;
            }

            element.x = totalWidth + element.width / 2;
            element.y = totalHeight + element.height / 2;
            lastHeight = vSpacing + element.height;

            totalWidth += spacing + element.width;
        }
    }
}
